/**
 * @deprecated use v2/components/error-boundary/CustomErrors.ts
 * @description
 *
 * Base class for defining custom errors. The purpose is to allow inherited custom errors to pass additional data to our ErrorBoundary's sentry logging when throwing the error (getContext).
 */
export class BaseCustomError extends Error {
  constructor(message) {
    var _Error$captureStackTr;
    super(message);
    this.name = this.constructor.name;

    // @ts-expect-error For proper stack trace
    (_Error$captureStackTr = Error.captureStackTrace) === null || _Error$captureStackTr === void 0 || _Error$captureStackTr.call(Error, this, this.constructor);
  }
}
export default BaseCustomError;